import React from 'react';
import ButtonBase, { IButtonCommonProps } from './base/ButtonBase';

interface IButtonProps extends IButtonCommonProps {
    text: string;
    onClick: () => void;
    disabled?: boolean;
}

const Button: React.FC<IButtonProps> = (props) => {
    return <ButtonBase {...props} />;
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/controls/forms/Button.tsx